
import { Autocomplete, CircularProgress, TextField } from '@material-ui/core';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import { useCallback, useEffect, useState } from 'react';
import { getCountriesv2 } from '../../api/elton-payments/country';
import { getCurrencies } from '../../api/elton-payments/currency';

export const CurrencyAutoComplete = ({ onChange, label, id, disabled, useSimple }: any) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [selected, setSelected] = useState<any>(null);
  const [currencies, setCurrencies]: any = useState<any[]>([]);

  useEffect(() => {
    (async () => {
      // Only do update on change
      if (selected && selected?.id === id) {
        return;
      }

      // If a given id is provided load a specific operator, otherwise load first 25
      const currencies = (await getCurrencies(1, 25, null, { id: selected?.id })).data.data;
      setCurrencies(currencies);
      if (id) {
        const currency = currencies.find((c: any) => c.primary_id === id);
        if (selected == null) setSelected(currency);
      }
    })();
  }, [id]);

  // Do Search after 600ms
  // const fetchCurrenciesDebounce = useCallback(AwesomeDebouncePromise(getCurrencies, 600), []);

  const handleUpdate = async (e: any) => {
    setLoading(true);
    const result = (await getCurrencies(1, 25, null, { id: selected?.id })).data.data;
    if (result) {
      setCurrencies(result);
      setLoading(false);
    }
  };

  /**
   * Update state when user selects a given operator
   * @param value
   */
  const handleSelect = async (value: string) => {
    setSelected(value);
    onChange(value ?? {});
  };

  return (
    <Autocomplete
      fullWidth
      disabled={disabled}
      openOnFocus={true}
      id={`${id}` || 'some-random-currency-id'}
      isOptionEqualToValue={(option: any, value: any) =>
        option && value && (option?.id === value?.id || option?.primary_id === value?.primary_id)
      }
      getOptionLabel={(option: any) => `${option.country_code} - ${option.currency}`}
      options={currencies}
      loading={loading}
      value={selected}
      onChange={(e: any, value: any) => handleSelect(value)}
      renderInput={(params) => (
        <TextField
          {...params}
          autoComplete="off"
          onChange={handleUpdate}
          label={useSimple ? '' : label || 'Currency'}
          InputProps={{
            ...params.InputProps,
            autoComplete: 'new-password-2',
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            )
          }}
        />
      )}
    />
  );
};
